import { render, staticRenderFns } from "./Icerik.vue?vue&type=template&id=09f684a1&scoped=true"
import script from "./Icerik.vue?vue&type=script&lang=js"
export * from "./Icerik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f684a1",
  null
  
)

export default component.exports